import getDecorators from "inversify-inject-decorators";
import container from "../../../ioc/inversify.config";
import TYPES from "../../../ioc/types";
import { ItemDefinitionDTO } from "../../../shared/dtos";
import { GeometryService } from "../../ui-services/geometry-ui-service";
import { TextContent } from "../text-content";

const { lazyInject } = getDecorators(container);

export class ItemDescription extends Phaser.GameObjects.Container {
    @lazyInject(TYPES.GeometryService)
    private geometryService: GeometryService;

    private boxHeight = 30;

    private description: TextContent;

    constructor(x: number, y: number, item: ItemDefinitionDTO, scene: Phaser.Scene) {
        super(scene, x, y);
        const screenWidth = scene.physics.world.bounds.width;
        const screenHeight = scene.physics.world.bounds.height;

        this.description = new TextContent(
            2,
            screenHeight - this.boxHeight,
            item.description,
            scene
        );
        const graphics = scene.add.graphics();

        this.geometryService.initGraphicContext(graphics);
        this.geometryService.drawBox(
            0,
            screenHeight - this.boxHeight - 2,
            screenWidth - 4,
            this.boxHeight
        );

        this.add(graphics);
        this.add(this.description);
    }

    public setDescription(description: string) {
        this.description.setText(description);
    }
}
